import { render, staticRenderFns } from "./SendNotificationMailInternComponent.vue?vue&type=template&id=7793fc35&scoped=true"
import script from "./SendNotificationMailInternComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendNotificationMailInternComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SendNotificationMailInternComponent.vue?vue&type=style&index=0&id=7793fc35&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7793fc35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7793fc35')) {
      api.createRecord('7793fc35', component.options)
    } else {
      api.reload('7793fc35', component.options)
    }
    module.hot.accept("./SendNotificationMailInternComponent.vue?vue&type=template&id=7793fc35&scoped=true", function () {
      api.rerender('7793fc35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/SendNotificationMailInternComponent.vue"
export default component.exports